import { useSelector } from "react-redux";
import ImageUploadModal from "../Modals/ImageUploadModal";
import useFileUpload from "./useFileUpload";
import ImageUploadMinimized from "../../components/Dashboard/ImageUploadMinimized";
import UploderClosinWarning from "../UploaderClosingWarning";

const FileUpload = () => {
  const { openUploadModal, openMiniBox } = useSelector(
    (state) => state.gallery
  );

  const {
    handleImageChange,
    uploadReadyImages,
    // uploadedCount,
    validImages,
    closeModal,
    handleCloseMiniMizedModal,
    uploadWarning,
    setUploadWarning,
    handleQuitUploading,
    handleDrop,
    handleDragOver,
    handleDragOut,
    // isUploading,
    uploadResponses,
    currentlyUploading,
    fileInputRef,
    fileUploadState,
  } = useFileUpload();
  return (
    <>
      <ImageUploadModal
        fileInputRef={fileInputRef}
        showModal={openUploadModal}
        setShowModal={closeModal}
        closeUploadModal={closeModal}
        handleDrop={handleDrop}
        handleDragOut={handleDragOut}
        handleDragOver={handleDragOver}
        handleImageChange={handleImageChange}
        uploadReadyImages={uploadReadyImages}
        // uploadedCount={uploadedCount}
        // validImages={validImages}
        // isUploading={isUploading}
        uploadResponses={uploadResponses}
        currentlyUploading={currentlyUploading}
        fileUploadState={fileUploadState}
      />

      {openMiniBox && (
        <ImageUploadMinimized
          setIsShowImageUpload={handleCloseMiniMizedModal}
          uploadReadyImages={uploadReadyImages}
          // uploadedCount={uploadedCount}
          validImages={validImages}
          uploadResponses={uploadResponses}
          currentlyUploading={currentlyUploading}
        />
      )}

      <UploderClosinWarning
        uploadAlert={uploadWarning}
        setUploadAlert={setUploadWarning}
        handleQuitUploading={handleQuitUploading}
      />
    </>
  );
};

export default FileUpload;
